import { isFileIdentifier } from '@atlaskit/media-client';
export var inputFromSource = function inputFromSource(source) {
  return {
    mouse: 'button',
    keyboard: 'keys'
  }[source];
};
export var createNavigatedEvent = function createNavigatedEvent(direction, source, identifier) {
  return {
    eventType: 'ui',
    action: 'navigated',
    actionSubject: 'file',
    actionSubjectId: direction === 'next' ? 'next' : 'previous',
    attributes: {
      fileAttributes: {
        fileId: isFileIdentifier(identifier) ? identifier.id : ''
      },
      input: inputFromSource(source)
    }
  };
};